import React, { useState } from 'react';
import { Container, Row, Col, InputGroup, InputGroupAddon, InputGroupText, Input, FormGroup,
   Button, Label, Form, FormFeedback } from 'reactstrap';
import logoImg from '../assets/images/forgot.png';
import Background from '../assets/images/paygovbackground.jpg';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FIRSTTIME_UPDATEPASSWORD_URL } from '../utils/APIEndpoints';
import { authHeader, loggedUserDetails } from '../utils/functions/CoreFunctions';
import API from '../redux/actions/API';
import { getAlertToast, getCurrentEmail } from '../utils/functions/CustomFunctions';
import Swal from 'sweetalert2';
import { SIGNIN_PATH } from '../utils/AppRoutes';
import { useHistory, Link } from 'react-router-dom';
import CustomLoader from './common/CustomLoader';

const validationSchema = Yup.object({
  oldPassword: Yup.string().required('Current Password Required'),
  newPassword: Yup.string().required('Password Required'),
  confirmPassword: Yup.string().required('Confirm Password Required')
  .test('passwords-match', 'Passwords must match', function(value) {
    return this.parent.newPassword === value;
  }),
});
 
const UpdatePassword = (props) => {

    const history = useHistory();
    const {role = ''} = loggedUserDetails();
    const [loading,setLoading] = useState(false);
    const [currentPasswordType,setCurrentPasswordType] = useState(true);
    const [newPasswordType,setNewPasswordType] = useState(true);
    const [confirmPasswordType,setConfirmPasswordType] = useState(true);

    const toggleCurrentPasswordType = () => {
        setCurrentPasswordType(!currentPasswordType);
    }
    const toggleNewPasswordType = () => {
        setNewPasswordType(!newPasswordType);
    }
    const toggleConfirmPasswordType = () => {
        setConfirmPasswordType(!confirmPasswordType);
    }

    const { handleSubmit, handleChange, values, errors,touched,setFieldTouched } = useFormik({
        initialValues: {
          email: getCurrentEmail(),
          oldPassword: '',
          newPassword: '',
          confirmPassword: ''
        },
        validationSchema,
        onSubmit(values) {
            updatePassword(values);  
        }
      });

    const updatePassword = async (values) => {
      try{
        setLoading(true); 
        const options = {
            method : 'PUT',
            url : FIRSTTIME_UPDATEPASSWORD_URL,
            headers: authHeader(),
            data: values
        }; 
        const response = await API(options);
        const {status, message } = response.data;
        if(status === 'Success')
        {
          Swal.fire(getAlertToast('success', message)); 
          history.push(SIGNIN_PATH);  
        }else{
          Swal.fire(getAlertToast('error', message)); 
        }
        }catch(error){
            if (error.response) {
            let { data } = error.response;
            Swal.fire(getAlertToast('error', data.message)); 
            }
        }finally{
            setLoading(false);
        }
    }

    return (
        <div className='loginbg' style={{backgroundImage: `url(${Background})`}}>
        <Container>
        <Row>
        <Col sm='12' md={{ size: 8, offset: 2 }}>
        <Row>
            <Col xs='6' className='loginbg-color'>
              <img src={logoImg} className='w-100' />
            </Col>
        <Col xs='6' className='bg-white p-4 pt-5 pb-5'>
        <h5 className='mb-4'>Update Password</h5>
        <Form onSubmit={handleSubmit}>
        <FormGroup>
        <Label for='exampleEmail'>Current Password</Label>
        <InputGroup>
        <Input name='oldPassword' placeholder='Enter Current Password'  
        type={currentPasswordType ? 'password' : 'text' }
        invalid={(errors.oldPassword && touched.oldPassword) ? true : false} 
                      onChange={(event) => {
                          setFieldTouched('oldPassword',true);
                          handleChange(event);
                      }}  
           values={values.oldPassword}/>
         <InputGroupAddon addonType="append">
                      <InputGroupText onClick={toggleCurrentPasswordType} style={{cursor:'pointer'}}>
                        {currentPasswordType ?
                        <i className="fas fa-eye-slash"/> : <i className="fas fa-eye"/>
                        }
                      </InputGroupText>
                      </InputGroupAddon>   
         <FormFeedback>{(errors.oldPassword && touched.oldPassword) ? errors.oldPassword : null}</FormFeedback>
        </InputGroup>
        </FormGroup>
        <FormGroup>
        <Label for='examplePassword'>New Password</Label>
        <InputGroup>
        <Input type={newPasswordType ? 'password' : 'text' } name='newPassword' placeholder='Enter Password' 
         invalid={(errors.newPassword && touched.newPassword) ? true : false} 
         onChange={(event) => {
             setFieldTouched('password',true);
             handleChange(event);
         }} 
         values={values.newPassword}/>
          <InputGroupAddon addonType="append">
                      <InputGroupText onClick={toggleNewPasswordType} style={{cursor:'pointer'}}>
                        {newPasswordType ?
                        <i className="fas fa-eye-slash"/> : <i className="fas fa-eye"/>
                        }
                      </InputGroupText>
                      </InputGroupAddon>  
          <FormFeedback>{(errors.newPassword && touched.newPassword) ? errors.newPassword : null}</FormFeedback>
        </InputGroup>  
      </FormGroup>
      <FormGroup>
        <Label for='examplePassword'>Confirm Password</Label>
        <InputGroup>
        <Input type={confirmPasswordType ? 'password' : 'text' } name='confirmPassword' placeholder='Enter Confirm Password' 
         invalid={(errors.confirmPassword && touched.confirmPassword) ? true : false} 
         onChange={(event) => {
             setFieldTouched('confirmPassword',true);
             handleChange(event);
         }} 
          values={values.confirmPassword}/>
           <InputGroupAddon addonType="append">
                      <InputGroupText onClick={toggleConfirmPasswordType} style={{cursor:'pointer'}}>
                        {confirmPasswordType ?
                        <i className="fas fa-eye-slash"/> : <i className="fas fa-eye"/>
                        }
                      </InputGroupText>
                      </InputGroupAddon>  
          <FormFeedback>{(errors.confirmPassword && touched.confirmPassword) ? errors.confirmPassword : null}</FormFeedback>
        </InputGroup>      
      </FormGroup>
        <div className='mt-5'>   
        <Button className='f-r' color='primary' type='submit' disabled={loading}>
        {loading && <CustomLoader loading={loading}/>}{' '}
        Update</Button>
        </div>
        </Form>
        </Col>
        </Row>
        </Col>
        </Row>
        </Container>
        </div>
    );
}

export default UpdatePassword;
